import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemSocialPinterest = function IconSystemSocialPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.431 13.721c.272.119.516.005.595-.315.054-.222.184-.782.242-1.015.08-.317.049-.428-.171-.703-.478-.601-.783-1.379-.783-2.48 0-3.193 2.244-6.052 5.845-6.052 3.188 0 4.939 2.074 4.939 4.844 0 3.643-1.515 6.718-3.764 6.718-1.242 0-2.17-1.093-1.874-2.434.358-1.6 1.049-3.328 1.049-4.484 0-1.035-.522-1.898-1.601-1.898-1.27 0-2.29 1.399-2.29 3.271 0 1.193.38 2 .38 2L7.47 18.059c-.454 2.043-.069 4.549-.036 4.802.02.15.2.186.282.072.118-.163 1.63-2.15 2.143-4.135.146-.562.836-3.473.836-3.473.412.837 1.618 1.575 2.9 1.575C17.41 16.9 20 13.197 20 8.24 20 4.49 17.018 1 12.485 1 6.845 1 4 5.304 4 8.894c0 2.174.773 4.108 2.431 4.827",
    clipRule: "evenodd"
  }));
};